import {
    ONLY_CHECKOUT_PATH,
    PAY_IN_PATH,
    PRE_ORDER_CONFIRMATION_ORGANIZER_QUESTIONS_PATH,
    PRE_TICKETS_ORGANIZER_QUESTIONS_PATH,
    TICKETS_COMPACT_SIZE_PATH,
    TICKETS_FULL_SIZE_PATH,
} from '../constants';
import { CheckoutState } from '../state';

export const getIsPaymentView = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    '/checkout-external/checkout';

export const getRoutePathname = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname;

export const isOrganizerQuestionsPage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${PRE_ORDER_CONFIRMATION_ORGANIZER_QUESTIONS_PATH}`;

export const isMyOrderFormPage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${PRE_TICKETS_ORGANIZER_QUESTIONS_PATH}`;

export const isPayInPage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${PAY_IN_PATH}`;

export const isTicketsCompactPage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${TICKETS_COMPACT_SIZE_PATH}`;

export const isOnlyCheckoutPage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${ONLY_CHECKOUT_PATH}`;

export const isTicketSelectionFullSizePage = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    `/checkout-external/${TICKETS_FULL_SIZE_PATH}`;
